/* Mint-Job: danh sách Job. Màu chỉ var(--…); độ đậm theo token. */
.page { display: flex; flex-direction: column; gap: 14px; padding: 0 0 24px; min-width: 0; }
.bar { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; }
.search { flex: 1 1 240px; max-width: 360px; margin-left: auto; }

.scroller {
  /* không có khung cuộn riêng: cả trang cuộn bằng `main` (như board); clip để bo góc mà th vẫn dính */
  overflow-x: clip;
  min-height: 240px;
  border-radius: 16px;
  background: var(--card);
  box-shadow: var(--sh);
}
.table { width: 100%; min-width: 1100px; border-collapse: separate; border-spacing: 0; table-layout: fixed; }
.table th {
  position: sticky;
  top: var(--page-head-h, 0px);
  z-index: 1;
  height: 43px;
  padding: 0 12px;
  background: var(--card);
  color: var(--lb);
  font-size: 12px;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  border-bottom: 1px solid var(--line);
}
.table td {
  height: 95px;
  padding: 12px 12px 0;
  vertical-align: top;
  border-bottom: 1px solid var(--line);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.table td.pad { height: auto; padding: 0; border: 0; }
.selCell { width: 44px; padding: 12px 0 0 18px !important; }
th.selCell { padding-top: 0 !important; vertical-align: middle; }
.check { width: 16px; height: 16px; margin: 0; accent-color: var(--pri); cursor: pointer; }
@media (hover: hover) {
  /* như board: ô chọn mờ khi chưa chọn gì, hiện mờ 0,45 khi rê dòng */
  .table:not([data-sel]) thead .check { opacity: 0.35; }
  .table:not([data-sel]) tbody .check { opacity: 0; }
  .table:not([data-sel]) tbody tr:hover .check { opacity: 0.45; }
  .check { transition: opacity 160ms; }
}
.rowOn td { background: var(--pri-bg); }
@media (hover: hover) {
  .table tbody tr:not(.rowOn):hover td { background: var(--sub); }
}

.sortBtn { display: inline-flex; gap: 4px; align-items: center; padding: 0; border: 0; background: transparent; font: inherit; color: inherit; cursor: pointer; }
.sortBtn:focus-visible, .jobNo:focus-visible, .dots:focus-visible { outline: 2px solid var(--pri); outline-offset: 2px; border-radius: 6px; }
th[aria-sort] .sortBtn { color: var(--tx); font-weight: var(--fw-title); }

.jobNo { padding: 0; border: 0; background: transparent; font: inherit; font-size: 13px; font-weight: var(--fw-label); color: var(--link); cursor: pointer; }
.stRow { display: flex; align-items: center; gap: 6px; margin-top: 6px; flex-wrap: wrap; }
.close { font-size: 11px; font-weight: var(--fw-label); color: var(--lb); }
.flags { display: flex; align-items: center; gap: 4px; margin-top: 4px; }

.main { font-size: 13px; font-weight: var(--fw-label); color: var(--tx); line-height: 20px; overflow: hidden; text-overflow: ellipsis; }
.muted { color: var(--lb); font-weight: var(--fw-body); }
.sub { display: flex; align-items: center; gap: 4px; min-width: 0; font-size: 12px; line-height: 20px; color: var(--lb); }
.sub span { min-width: 0; overflow: hidden; text-overflow: ellipsis; }
.sub svg { flex-shrink: 0; }
.hot { color: var(--err); font-weight: var(--fw-title); }
.chips { display: flex; gap: 4px; margin-top: 3px; }
.svc { height: 20px; padding: 0 7px; border-radius: 6px; font-size: 11px; line-height: 20px; font-weight: var(--fw-label); background: var(--ctl); color: var(--tx2); }
.more { font-size: 11px; line-height: 20px; color: var(--lb); }

.act { display: flex; flex-direction: column; align-items: center; gap: 6px; width: 40px; }
.dots { display: inline-flex; align-items: center; justify-content: center; width: 32px; height: 28px; border: 0; border-radius: 9px; background: transparent; color: var(--tx2); cursor: pointer; }
@media (hover: hover) {
  .dots:hover { background: var(--ctl); }
}
.pic { display: inline-flex; align-items: center; justify-content: center; width: 26px; height: 26px; border-radius: 50%; background: var(--ctl); color: var(--tx2); font-size: 10px; font-weight: var(--fw-title); }
.prog { width: 36px; height: 4px; border-radius: 2px; background: var(--line); overflow: hidden; }
.prog > div { height: 100%; border-radius: 2px; background: var(--d-blue); }

@media (max-width: 1439px) {
  col.cmp { visibility: collapse; width: 0 !important; }
}
@media (max-width: 1279px) {
  col.minor { visibility: collapse; width: 0 !important; }
}
@media (max-width: 767px) {
  .page { padding: 0 0 16px; }
  .search { max-width: none; margin-left: 0; }
}

/* iPad + điện thoại: chip nhanh, thẻ (Mint-Job-iPad, Mint-Job-Phone) */
.quick { display: inline-flex; align-items: center; gap: 6px; height: 44px; padding: 0 14px; border: 0; border-radius: 12px; background: var(--ctl); color: var(--tx2); font: inherit; font-size: 14px; font-weight: var(--fw-label); cursor: pointer; white-space: nowrap; }
.quick:focus-visible, .cardBody:focus-visible, .cardMore:focus-visible, .gridCard:focus-visible, .fab:focus-visible { outline: 2px solid var(--pri); outline-offset: 2px; }
.quickOn { background: var(--pri-bg); color: var(--link); }
.viewSw { margin-left: 4px; }
.searchOff { display: none; }

.cardScroll { min-height: 240px; }
.cardList { padding: 0; }
.cardWrap { height: 194px; padding-bottom: 10px; box-sizing: border-box; }
.card { position: relative; height: 184px; border-radius: 18px; background: var(--ctl); box-shadow: var(--sh); overflow: hidden; }
.cardFace { position: relative; height: 100%; border-radius: 18px; background: var(--card); transition: transform 220ms cubic-bezier(.16, 1, .3, 1); touch-action: pan-y; }
.tray { position: absolute; top: 0; right: 0; bottom: 0; width: 264px; display: flex; }
.trayBtn { flex: 1 1 0; display: inline-flex; align-items: center; justify-content: center; gap: 6px; border: 0; background: var(--ctl-on); color: var(--tx); font: inherit; font-size: 13px; font-weight: var(--fw-label); cursor: pointer; }
.trayPri { background: var(--btn); color: var(--btn-tx); }
.trayWarn { background: var(--warn-bg); color: var(--warn); }
@media (prefers-reduced-motion: reduce) { .cardFace { transition: none; } }
.cardBody { display: flex; flex-direction: column; gap: 3px; width: 100%; height: 100%; box-sizing: border-box; padding: 14px 52px 14px 16px; border: 0; border-radius: 18px; background: transparent; color: var(--tx); font: inherit; text-align: left; cursor: pointer; overflow: hidden; }
.cardHead { display: flex; align-items: center; gap: 8px; }
.cardNo { font-weight: var(--fw-title); color: var(--link); }
.cardCus { line-height: 22px; font-weight: var(--fw-label); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.cardLine { line-height: 20px; display: flex; align-items: center; gap: 6px; min-width: 0; font-size: 14px; color: var(--tx2); }
.cardLine > span:not(:last-child) { min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.cardLine svg { flex-shrink: 0; }
.cardSub { min-width: 0; max-width: 100%; font-size: 13px; line-height: 20px; color: var(--lb); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.cardMuted { display: inline-flex; align-items: center; gap: 4px; font-size: 13px; color: var(--lb); }
.cardFoot { display: flex; align-items: center; justify-content: space-between; gap: 8px; margin-top: auto; }
.cutChip { display: inline-flex; align-items: center; gap: 4px; padding: 3px 10px; border-radius: 999px; background: var(--ctl); color: var(--tx2); font-size: 13px; font-weight: var(--fw-label); }
.cutHot { background: var(--err-bg); color: var(--err); }
.cardMore { position: absolute; top: 6px; right: 6px; display: inline-flex; align-items: center; justify-content: center; width: 44px; height: 44px; border: 0; border-radius: 12px; background: transparent; color: var(--tx2); cursor: pointer; }
.cardHead :global(span:last-child) { margin-left: auto; }
.cardMore { top: auto; bottom: 6px; }

.grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 12px; }
.gridCard { display: flex; flex-direction: column; align-items: flex-start; gap: 4px; height: 130px; box-sizing: border-box; padding: 14px 16px; border: 0; border-radius: 18px; background: var(--card); box-shadow: var(--sh); color: var(--tx); font: inherit; text-align: left; cursor: pointer; overflow: hidden; }
.gridCard .cardHead { width: 100%; }
.gridCard .cutChip { margin-top: auto; }
@media (hover: hover) {
  .quick:hover, .cardMore:hover { background: var(--ctl); }
  .gridCard:hover { box-shadow: var(--sh), 0 0 0 1px var(--bd); }
}

.fab { position: fixed; right: 18px; bottom: 24px; z-index: 5; display: inline-flex; align-items: center; justify-content: center; width: 56px; height: 56px; border: 0; border-radius: 28px; background: var(--btn); color: var(--btn-tx); cursor: pointer; box-shadow: var(--sh); }
@media (hover: hover) {
  .fab:hover { background: var(--btn-hov); }
}
@media (max-width: 767px) {
  .fab { bottom: 96px; }
  .bar { flex-wrap: nowrap; overflow-x: auto; scrollbar-width: none; }
  .bar > * { flex-shrink: 0; }
  .search { flex: 1 0 100%; max-width: none; }
}
@media (max-width: 1279px) {
  .table { min-width: 900px; }
}

/* Mint-Job desktop: tab đầu trang · thanh tìm / thời gian / Lọc · dải tổng + Lưu view + kiểu xem */
.barOff { display: none; }
.tabsRow { display: flex; align-items: center; gap: 4px; }
.moreWrap { position: relative; }
.moreBtn { display: inline-flex; align-items: center; gap: 4px; height: 34px; padding: 0 12px; border: 0; border-radius: 9px; background: transparent; color: var(--tx2); font: inherit; font-size: 13px; font-weight: var(--fw-label); cursor: pointer; }
.moreOn { color: var(--tx); }
.pop { position: absolute; left: 0; top: calc(100% + 6px); z-index: 30; min-width: 170px; padding: 6px; border-radius: 14px; background: var(--card); box-shadow: var(--pop, var(--sh)); }
.popItem { display: flex; align-items: center; justify-content: space-between; width: 100%; height: 34px; padding: 0 10px; border: 0; border-radius: 9px; background: transparent; color: var(--tx); font: inherit; font-size: 13px; cursor: pointer; text-align: left; }
.popN { font-size: 12px; color: var(--lb); }
.tb { display: flex; gap: 8px; align-items: center; height: 42px; }
.tbSearch { display: flex; align-items: center; gap: 10px; width: 300px; height: 42px; box-sizing: border-box; padding: 0 14px; border-radius: 12px; background: var(--card); box-shadow: var(--sh); color: var(--lb); }
.tbSearch input { flex: 1; min-width: 0; border: 0; outline: 0; background: transparent; font: inherit; font-size: 13px; color: var(--tx); }
.scope { flex-shrink: 0; height: 28px; border: 0; border-radius: 8px; background: var(--ctl); color: var(--tx2); font: inherit; font-size: 12px; font-weight: var(--fw-label); padding: 0 4px; }
.tbBtn { display: inline-flex; align-items: center; gap: 8px; height: 42px; padding: 0 12px; border: 0; border-radius: 12px; background: var(--card); box-shadow: var(--sh); color: var(--tx); font: inherit; font-size: 13px; font-weight: var(--fw-label); cursor: pointer; white-space: nowrap; }
.tbBtn svg { color: var(--lb); }
.tbCtl { background: var(--ctl); box-shadow: none; padding: 0 14px; }
.tbCtl svg { color: inherit; }
.sumRow { display: flex; gap: 8px; align-items: center; height: 34px; font-size: 13px; }
.sum { display: flex; gap: 14px; color: var(--tx2); white-space: nowrap; }
.sum b { color: var(--tx); font-weight: var(--fw-title); }
.sum b.sumHot { color: var(--err); }
.saveView { display: inline-flex; align-items: center; gap: 6px; height: 34px; padding: 0 10px; border: 0; border-radius: 10px; background: transparent; color: var(--link); font: inherit; font-size: 13px; font-weight: var(--fw-label); cursor: pointer; white-space: nowrap; }
.sumEnd { display: flex; gap: 8px; align-items: center; margin-left: auto; }
.tbCtl2 { display: inline-flex; align-items: center; gap: 6px; height: 34px; padding: 0 10px; border: 0; border-radius: 10px; background: var(--ctl); color: var(--tx); font: inherit; font-size: 12px; font-weight: var(--fw-label); cursor: pointer; white-space: nowrap; }
@media (hover: hover) {
  .moreBtn:hover, .popItem:hover { background: var(--ctl); }
  .saveView:hover { background: var(--ctl); }
}

.stBtn { display: inline-flex; padding: 0; border: 0; background: none; font: inherit; font-size: 12px; font-weight: 550; color: inherit; cursor: pointer; }
.foot { height: 44px; display: flex; align-items: center; justify-content: space-between; padding: 0 18px; color: var(--lb); font-size: 12px; }
.pager { display: flex; gap: 6px; }
.pager button { width: 34px; height: 34px; border: 0; border-radius: 10px; background: var(--ctl); color: var(--tx2); font: inherit; cursor: pointer; }
.vlink { display: block; max-width: 100%; padding: 0; border: 0; background: none; font: inherit; font-size: 13px; font-weight: var(--fw-label); text-align: left; cursor: pointer; }
@media (hover: hover) { .vlink:hover { text-decoration: underline; } }
.phoneBar { display: flex; align-items: center; gap: 8px; width: 100%; }
.phoneFilter { margin-left: auto; }
.phoneBar .quick { padding: 0 12px; flex-shrink: 0; }
.phoneBar { gap: 6px; }
.tbSearchPad { width: 300px; padding: 0 8px 0 6px; flex-shrink: 1; min-width: 180px; }
.qGroup { display: flex; gap: 2px; padding: 3px; border-radius: 12px; background: var(--ctl); }
.qBtn { min-width: 44px; height: 36px; padding: 0 10px; border: 0; border-radius: 9px; background: transparent; color: var(--tx2); font: inherit; font-size: 13px; font-weight: var(--fw-label); cursor: pointer; white-space: nowrap; }
.qOn { background: var(--card); color: var(--tx); box-shadow: var(--sh); }
.routeSub { display: flex; gap: 8px; align-items: center; }
.table th:last-child { font-size: 0; }
